import logger from 'utils/logger-aws'
import { ComponentItem, DynamicComponentProps } from '~types'
import { isComponentOfType } from 'utils'
import { EyebrowProps, FormProps } from '~types'
import * as Modules from '~modules'
import * as Elements from '~elements'

const DynamicComponent = ({ block, isChildOfModal = false }: DynamicComponentProps) => {
  const aliasMap: Record<string, string> = {
    ContentHeading: 'Heading'
  }

  const rawName = block?.componentName
  const componentName = (rawName && aliasMap[rawName]) ?? rawName

  const modules = Modules as Record<string, React.ComponentType<any>>
  const elements = Elements as Record<string, React.ComponentType<any>>

  const Component = componentName ? modules[componentName] || elements[componentName] : undefined

  if (!Component) {
    const isEmptyObject = block && Object.keys(block).length === 0
    const message = `[DynamicComponent] ❌ "${block.componentName}" not found in components list.${
      isEmptyObject ? ' Empty block object detected; check for unsupported components in Hygraph.' : ''
    }`
    console.error(message)
    logger.error(message)
    return null
  }

  const enhancedBlock: ComponentItem = {
    ...block,
    ...(isComponentOfType<EyebrowProps>(block, 'Eyebrow') && {
      // @ts-ignore
      color: block.eyebrowColor,
      // @ts-ignore
      size: block.eyebrowSize
    }),
    ...(isChildOfModal &&
      isComponentOfType<FormProps>(block, 'Form') && {
        isChildOfModal: true
      })
  }

  return Component ? <Component {...enhancedBlock} /> : null
}

export default DynamicComponent
